import * as React from 'react';
import { observer } from 'mobx-react';

import PreviewStore from '../Store';
import Modal from '../../../../../../Modal';
import Button from '../../../../../../Form/Button';
import { T } from '../../../../../../../Translations';
import ModalStore from '../../../../../../Modal/Store';
import IframeContentStore from '../IframeContent/Store';

export interface Props {
  modalStore: ModalStore;
  previewStore: PreviewStore;
  iframeContentStore: IframeContentStore;
}

const LeaveEditModeModal: React.FC<Props> = ({ modalStore, previewStore, iframeContentStore }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      const handleDiscardChanges = () => {
        modalStore.close();
        previewStore.leaveEditMode();
        previewStore.learningCollectionStore.discardChanges();
      };

      return (
        <Modal
          close={handleDiscardChanges}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Unsaved Changes" />
            </h3>
          }
        >
          <div>
            <p className="mb-9 text-sm">
              <T kind="You have unsaved changes. Please..." />
            </p>
            <div className="flex justify-end">
              <Button
                type="button"
                value="Discard Changes"
                onClick={handleDiscardChanges}
                className="bg-white text-sm text-teal-600"
              />
              <Button
                type="button"
                value="Save Changes"
                onClick={() => {
                  modalStore.close();
                  iframeContentStore.loading();
                  previewStore.leaveEditMode();
                  previewStore.learningCollectionStore.previewingUpdating(
                    iframeContentStore,
                    previewStore,
                  );
                }}
                className="ml-5 rounded bg-teal-600 py-2.5 px-5 text-sm text-white"
              />
            </div>
          </div>
        </Modal>
      );
  }
};

export default observer(LeaveEditModeModal);
